import React from 'react';
import { styled as styled2 } from '@compiled/react';
import { useFragment, graphql } from 'react-relay';
import CommentIcon from '@atlaskit/icon/glyph/comment';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { commentsCell_softwareCodePage$key } from '@atlassian/jira-relay/src/__generated__/commentsCell_softwareCodePage.graphql';

type CommentsCellProps = {
	commentsCellData: commentsCell_softwareCodePage$key;
};

const CommentsCell = ({ commentsCellData }: CommentsCellProps) => {
	const { commentCount } = useFragment(
		graphql`
			fragment commentsCell_softwareCodePage on DevOpsPullRequestDetails {
				commentCount
			}
		`,
		commentsCellData,
	);

	return (
		/* @ts-expect-error - Type 'number | null | undefined' is not assignable to type 'number | null'. */
		<Wrapper commentCount={commentCount}>
			<CommentIcon label="" size="medium" />
			<CommentCount>{commentCount || 0}</CommentCount>
		</Wrapper>
	);
};

export default CommentsCell;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled2.div<{ commentCount: number | null }>({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ commentCount }) =>
		commentCount && commentCount > 0
			? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				token('color.text', colors.N900)
			: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
				token('color.icon.disabled', colors.N70),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CommentCount = styled2.span({
	marginLeft: token('space.025', '2px'),
});
